<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-overflow`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 29v16a1 1 0 01-1 1h-2a1 1 0 01-1-1V29h4zM10 7a1 1 0 011 1v33a1 1 0 01-1 1H8a1 1 0 01-1-1V8a1 1 0 011-1h2zm23 23.046l-.001-4.047L19 26a1 1 0 01-1-1v-2a1 1 0 011-1h14v-4.046a1.4 1.4 0 012.286-1.083l7.39 6.046a1.4 1.4 0 010 2.166l-7.39 6.046A1.4 1.4 0 0133 30.046zM24 2a1 1 0 011 1v16h-4V3a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconOverflow',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
